var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeaturedOne(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3348_16331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 11C3 5.75329 7.25329 1.5 12.5 1.5H40.5C45.7467 1.5 50 5.75329 50 11V39C50 44.2467 45.7467 48.5 40.5 48.5H12.5C7.25329 48.5 3 44.2467 3 39V11Z",
    stroke: "#2563EB",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8834 16.95C29.8834 16.95 29.6501 17.02 29.2534 17.1483C29.1834 16.9383 29.0901 16.67 28.9501 16.4133C28.5068 15.5617 27.8534 15.1183 27.0601 15.1067C27.0018 15.1067 26.9551 15.1067 26.8968 15.1183C26.8734 15.095 26.8501 15.06 26.8268 15.0367C26.4884 14.6633 26.0451 14.4883 25.5201 14.5C24.5051 14.535 23.4901 15.27 22.6618 16.5767C22.0784 17.4983 21.6468 18.6533 21.5184 19.54C20.3518 19.9017 19.5351 20.1583 19.5118 20.1583C18.9168 20.345 18.9051 20.3683 18.8234 20.9167C18.7651 21.3367 17.2251 33.2833 17.2251 33.2833L30.0351 35.5V16.9267C29.9768 16.9267 29.9184 16.9383 29.8834 16.95ZM26.9201 17.8717C26.2434 18.0817 25.4968 18.315 24.7618 18.5367C24.9718 17.7317 25.3684 16.9383 25.8584 16.4133C26.0451 16.215 26.2901 16.005 26.5934 15.8767C26.8734 16.4717 26.9318 17.3 26.9201 17.8717ZM25.5318 15.1767C25.7651 15.1767 25.9751 15.2233 26.1501 15.34C25.8701 15.48 25.6134 15.69 25.3568 15.9583C24.7151 16.6467 24.2134 17.7317 24.0151 18.77C23.3968 18.9567 22.8018 19.1433 22.2418 19.3183C22.5918 17.6733 23.9684 15.2233 25.5318 15.1767ZM23.5484 24.4983C23.6184 25.5833 26.4884 25.8283 26.6518 28.3833C26.7801 30.39 25.5901 31.7667 23.8634 31.8717C21.8101 32 20.6668 30.7867 20.6668 30.7867L21.0984 28.9317C21.0984 28.9317 22.2418 29.795 23.1518 29.7367C23.7468 29.7017 23.9568 29.2117 23.9451 28.8733C23.8518 27.45 21.5184 27.5317 21.3784 25.1983C21.2501 23.2267 22.5451 21.2433 25.3918 21.0567C26.5001 20.9867 27.0601 21.2667 27.0601 21.2667L26.4068 23.705C26.4068 23.705 25.6834 23.3783 24.8201 23.425C23.5601 23.5067 23.5368 24.3 23.5484 24.4983ZM27.5968 17.6617C27.5851 17.1483 27.5268 16.425 27.2818 15.8067C28.0518 15.9583 28.4368 16.8217 28.6001 17.3467C28.3084 17.44 27.9701 17.545 27.5968 17.6617ZM30.4551 35.4533L35.7751 34.135C35.7751 34.135 33.4884 18.665 33.4768 18.56C33.4651 18.455 33.3718 18.3967 33.2901 18.385C33.2084 18.3733 31.7151 18.35 31.7151 18.35C31.7151 18.35 30.8051 17.4633 30.4551 17.125V35.4533Z",
    fill: "#2563EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3348_16331",
    x: 0.5,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3348_16331"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3348_16331",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedOne);
export default __webpack_public_path__ + "static/media/Featured_one.1060f851afbcc4b18a05f62b646b2576.svg";
export { ForwardRef as ReactComponent };